import { render } from "./CampaignOnlyActivities.vue?vue&type=template&id=dcca58ee&scoped=true"
import script from "./CampaignOnlyActivities.vue?vue&type=script&lang=js"
export * from "./CampaignOnlyActivities.vue?vue&type=script&lang=js"

import "./CampaignOnlyActivities.vue?vue&type=style&index=0&id=dcca58ee&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcca58ee"]])

export default __exports__